import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import styles from './Login.module.css';
import { Eye, EyeOff } from 'lucide-react';
import { CgLock } from "react-icons/cg";
import { useTheme } from "../ThemeContext/ThemeContext";
import { useNavVisibility } from '../NavVisibilityContext/NavVisibilityContext';
import logo from '../../assets/logo.svg';
import logoLight from '../../assets/logo-light.svg';
import authApi from "../../utils/auth.api";

const ResetPassword = ({ handleShowHeader, handleShowSettingsHeader }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const { isDarkMode } = useTheme();
    const { setIsNavVisible } = useNavVisibility();
    const logoSrc = isDarkMode ? logoLight : logo;

    useEffect(() => {
        handleShowHeader(false);
        handleShowSettingsHeader(false);
        setIsNavVisible(false);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await authApi.resetPassword(
                searchParams.get('token'),
                searchParams.get('client_id'),
                password,
                passwordConfirmation
            );

            if (response.success) {
                setSuccess(response.message);
                setError('');
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            } else {
                setError(response.message);
                setSuccess('');
            }
        } catch (err) {
            setError(err.message);
            setSuccess('');
        }
    };

    return (
        <div className={styles.container}>
            <Link to={"https://mckinneytaxservices.com"} className={styles.logoWrap}>
                <h2 className={styles.logoText}>McKinney Tax Services</h2>
                <div className={styles.logoContainer}>
                    <img src={logoSrc} alt="Logo" className={styles.logo}/>
                </div>
            </Link>

            <div className={styles.formContainer}>
                <div className={styles.formCard}>
                    <h2 className={styles.title}>Reset Password</h2>
                    <form onSubmit={handleSubmit} className={styles.form}>
                        <div className={styles.inputWrap}>
                            <div className={styles.inputGroup}>
                                <div className={styles.inputWrapper}>
                                    <CgLock className={styles.icon}/>
                                    <input
                                        className={styles.input}
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        placeholder="New Password"
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className={styles.togglePassword}
                                    >
                                        {showPassword ? (
                                            <EyeOff className={styles.icon}/>
                                        ) : (
                                             <Eye className={styles.icon}/>
                                         )}
                                    </button>
                                </div>
                            </div>
                            <div className={styles.inputGroup}>
                                <div className={styles.inputWrapper}>
                                    <CgLock className={styles.icon}/>
                                    <input
                                        className={styles.input}
                                        type={showConfirmPassword ? "text" : "password"}
                                        value={passwordConfirmation}
                                        placeholder="Confirm New Password"
                                        onChange={(e) => setPasswordConfirmation(e.target.value)}
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        className={styles.togglePassword}
                                    >
                                        {showConfirmPassword ? (
                                            <EyeOff className={styles.icon}/>
                                        ) : (
                                             <Eye className={styles.icon}/>
                                         )}
                                    </button>
                                </div>
                            </div>
                            {error && (
                                <div className="text-red-700 font-bold text-sm my-2">
                                    {error}
                                </div>
                            )}
                            {success && (
                                <div className="text-green-700 font-bold text-sm my-2">
                                    {success}
                                </div>
                            )}
                        </div>

                        <div className={styles.buttonGroup}>
                            <div className={styles.registerLink}>
                                <span>Remember your password? </span>
                                <br/>
                                <Link to="/login">Back to login</Link>
                            </div>
                            <button className={styles.submitButton} type="submit">
                                Reset Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
